export default "__VITE_ASSET__b8cb0d6f__"